// @flow
import React from 'react';
import classNames from 'classnames';
import ReactDropdown from 'react-dropdown';
//eslint-disable-next-line
import styles from "./styles.scss";

type Option = {
  value: number | string,
  label: string,
};

type Props = {
  options: Array<Option>,
  value?: number | string,
  onSelect: (id: number | string) => void,
  placeholder?: string,
  className?: string,
  mode?: string,
};

const SortDropDown = (props: Props) => {
  const {
    className,
    onSelect,
    options,
    placeholder = options[0],
    value,
    mode,
  } = props;

  const containerClassName = classNames('sort-dropdown', className, mode);

  const selectedOption =
    value && value !== '' ? options.find(data => data.value === value) : null;

  return (
    <div className={containerClassName}>
      <ReactDropdown
        placeholder={placeholder}
        id={'sort-dropdown'}
        name={'sort'}
        options={options}
        value={selectedOption}
        onChange={onSelect}
        arrowClosed={<span className="arrow-closed" />}
        arrowOpen={<span className="arrow-open" />}
      />
    </div>
  );
};

export default SortDropDown;
